export const PROMO_LINK = 'https://www.cian.ru/cian_new/?utm_source=guide&utm_medium=smb&utm_campaign=banner';

export const ADD_ADVERT =
  'https://www.cian.ru/razmestit-obyavlenie/?utm_source=guide&utm_medium=smb&utm_campaign=banner';
